module.exports = __webpack_public_path__ + "img/kuaidi.e8a0fc6.jpg";